// CalendarSettings.js
import React, { useState, useEffect, useCallback } from "react";
import StickyHeader from "../../../../../components/ModuleCommon/StickyHeader/StickyHeader";
import { fetchLocationsByOfficeCodes } from "../../../Manage-Team/api";
import AddDockModal from "../../Modal/AddDockModal";
import WarehouseDockManagement from "./WarehouseDockManagement";
import Cookies from "js-cookie";
import axios from "axios";
import { fetchCalendarByRefForDate } from "../api/AppointmentsApi";
import { Plus } from "lucide-react"; 
import notify from "../../../../../components/ACS-Dashboard/ACS-Blocks/Toast";
import { useDispatch, useSelector } from "react-redux";
import {
  setLastSettingsLocation,
  setLastSettingsWarehouse,
} from "../../../../../redux/slices/appointmentsSlices";

const CalenderSettings = () => {
  const dispatch = useDispatch();
  const { lastSettingsLocation, lastSettingsWarehouse } = useSelector(
    (state) => state.appointments
  );
  const [locations, setLocations] = useState([]);
  const [selectedLocationId, setSelectedLocationId] = useState("");
  const [selectedWarehouseIndex, setSelectedWarehouseIndex] = useState(null);
  const officeCode = Cookies.get("officeCode");
  const [activeTarget, setActiveTarget] = useState({ type: "warehouse" }); 
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingWarehouses, setIsLoadingWarehouses] = useState(false);
  const [openAddDockModal, setOpenAddDockModal] = useState(false);
  const [infoData, setInfoData] = useState({
    Location: {
      label: "Location",
      type: "dropdown",
      value: "Select Location",
      options: [],
      isPlaceholder: true,
    },
    Warehouse: {
      label: "Warehouse",
      type: "dropdown",
      value: "Select Warehouse",
      options: [],
      isPlaceholder: true,
    },
  });

  const getLocKey = (loc) => loc?.uid ?? loc?.id ?? loc?.locationRef;


const loadWarehousesForLocation = useCallback(
  async (loc) => {
    setIsLoadingWarehouses(true);
    try {
      const whRes = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/locations/children/by-id?parentId=${loc.id}`
      );
      const rawWarehouses = whRes.data ?? [];

      const enrichedWarehouses = await Promise.all(
        rawWarehouses.map(async (warehouse) => {
          let warehouseSettings;
          try {
            const calData = await fetchCalendarByRefForDate(
              warehouse?.calendar?.calendarRefId
            );
            warehouseSettings = transformApiResponseToDockSettings(calData);
          } catch {
            warehouseSettings = {
              maxCapacity: 10,
              appointmentDuration: 120,
              regularHours: {},
              holidays: [],
              blackouts: [],
            };
          }

          let docks = [];
          try {
            const docksRes = await axios.get(
              `${process.env.REACT_APP_API_BASE_URL}/api/dock/docks/${warehouse.locationRef}`
            );
            const rawDocks = docksRes.data ?? [];
            docks = await Promise.all(
              rawDocks.map(async (dock) => {
                if (dock.calendarRefId) {
                  try {
                    const calData = await fetchCalendarByRefForDate(dock.calendarRefId);
                    const dockSettings = transformApiResponseToDockSettings(calData);
                    return { ...dock, settings: dockSettings };
                  } catch (err) {
                    return { ...dock, settings: warehouseSettings };
                  }
                } else {
                  return { ...dock, settings: warehouseSettings };
                }
              })
            );
          } catch {
            docks = [];
          }

          return { ...warehouse, settings: warehouseSettings, docks };
        })
      );

      console.log("📦 Warehouses with docks (after fetch)", {
        location: loc.locationName,
        warehouses: enrichedWarehouses,
      });

      setLocations(prev =>
        prev.map(l =>
          l.uid === loc.uid ? { ...l, warehouses: enrichedWarehouses } : l
        )
      );
    } catch (err) {
      console.error("Failed to load warehouses:", err);
    } finally {
      setIsLoadingWarehouses(false);
    }
  },
  []
);

const handleInfoChange = async (field, newValue) => {
  if (field === "Location") {
    const loc = locations.find((l) => l.locationName === newValue);
    if (loc) {
      const locKey = getLocKey(loc);
      setSelectedLocationId(locKey);
      setSelectedWarehouseIndex(null);

      dispatch(
        setLastSettingsLocation({
          id: locKey,
          locationRef: loc.id ?? loc.locationRef ?? loc.uid,
          locationName: loc.locationName,
        })
      );
      dispatch(setLastSettingsWarehouse(null));

      setInfoData(prev => ({
        ...prev,
        Location: { ...prev.Location, value: newValue },
        Warehouse: { ...prev.Warehouse, value: "Select Warehouse", options: [] }
      }));

      await loadWarehousesForLocation(loc);
    }
  }

  if (field === "Warehouse") {
    const wh = selectedLocation?.warehouses?.find(w => w.locationName === newValue);
    if (wh) {
      setSelectedWarehouseIndex(
        selectedLocation.warehouses.indexOf(wh)
      );

      dispatch(
        setLastSettingsWarehouse({
          id: wh.uid ?? wh.locationRef,
          locationRef: wh.locationRef,
          locationName: wh.locationName,
        })
      );

      setInfoData(prev => ({
        ...prev,
        Warehouse: { ...prev.Warehouse, value: newValue }
      }));

      setActiveTarget({ type: "warehouse" });

      setLocations(prev => {
        const next = structuredClone(prev);
        const loc = next.find(l => getLocKey(l) === selectedLocationId);

        if (loc?.warehouses?.length) {
          const newWh = loc.warehouses.find(w => w.locationName === newValue);
          if (newWh?.docks?.length) {
            newWh.docks = newWh.docks.map(d => ({ ...d, selected: false }));
          }
        }

        return next;
      });
    }
  }
};




// { type: "warehouse" } or { type: "dock", idx }

  const transformApiResponseToDockSettings = (apiResponse) => {
    console.log("📥 calendar response", {
      calendarRefId: apiResponse?.calendarRefId,
      appointmentDuration: apiResponse?.appointmentDuration,
      eventCount: apiResponse?.event?.length,
      exceptionCount: apiResponse?.exceptionEvent?.length,
      sampleEvents: (apiResponse?.event || []).slice(0, 3).map((evt) => ({
        recurringType: evt.recurringType,
        eventTypeName: evt.eventTypeName,
        eventStatusType: evt.eventStatusType,
        event_statue_type: evt.event_statue_type,
        event_recurring_type: evt.event_recurring_type,
        dayOfWeek: evt.dayOfWeek,
        startTime: evt.startTime,
        endTime: evt.endTime,
        monthOfYear: evt.monthOfYear,
        dayOfMonth: evt.dayOfMonth,
      })),
      sampleExceptions: (apiResponse?.exceptionEvent || []).slice(0, 3).map((ex) => ({
        overrideType: ex.overrideType,
        startDate: ex.startDate,
        endDate: ex.endDate,
        isWholeDay: ex.isWholeDay,
      })),
    });
    const regularHours = {};
    const holidays = [];
    const blackouts = [];

    for (const evt of apiResponse.event || []) {
      const recurringType = evt.event_recurring_type || evt.recurringType;
      const statusType =
        evt.event_statue_type || evt.eventStatusType || evt.eventTypeName;

      if (
        recurringType &&
        statusType &&
        recurringType.toUpperCase() === "WEEKLY" &&
        statusType.toUpperCase() === "OPEN"
      ) {
        const day = capitalizeFirstLetter(evt.dayOfWeek?.toLowerCase());
        if (day) {
          regularHours[day] = {
            from: evt.startTime?.slice(0, 5) || "09:00",
            to: evt.endTime?.slice(0, 5) || "17:00",
            eventId: evt.eventId,
          };
        }
      }

      if (
        recurringType &&
        statusType &&
        recurringType.toUpperCase() === "YEARLY" &&
        statusType.toUpperCase() === "CLOSE"
      ) {
        const month = evt.monthOfYear?.toString().padStart(2, "0");
        const day = evt.dayOfMonth?.toString().padStart(2, "0");
        if (month && day) {
          const baseDate = evt.startDate || evt.start_date;
          const parsedBase = baseDate ? new Date(baseDate) : null;
          const year = parsedBase && !isNaN(parsedBase.getTime())
            ? parsedBase.getFullYear()
            : new Date().getFullYear();
          holidays.push({
            date: `${year}-${month}-${day}`,
            allDay: true,
            reason: evt.eventDescription,
            eventId: evt.eventId,
          });
        }
      }
    }

    for (const ex of apiResponse.exceptionEvent || []) {
      // Optional: validate overrideType === 'CLOSE' only
      if ((ex.overrideType || "").toUpperCase() === "CLOSE") {
        blackouts.push({
          from: ex.startDate,
          to: ex.endDate || ex.startDate,
          allDay: ex.isWholeDay === true,
          reason: ex.reason,
          exceptionId: ex.exceptionId,
        });
      }
    }

    return {
      regularHours,
      holidays,
      blackouts,
      calendarId: apiResponse.calendarId,
      calendarRefId: apiResponse.calendarRefId,
      appointmentDuration: apiResponse.appointmentDuration,
    };
  };

  const capitalizeFirstLetter = (str) =>
    str.charAt(0).toUpperCase() + str.slice(1);

const selectedLocation = locations.find(
    (loc) => getLocKey(loc) === selectedLocationId
  );
  const selectedWarehouse =
    selectedLocation?.warehouses?.[selectedWarehouseIndex] || null;

      useEffect(() => {
  setInfoData(prev => ({
    ...prev,
    Location: {
      ...prev.Location,
      value: selectedLocation?.locationName || "Select Location",
      options: locations.map(l => l.locationName),
      isPlaceholder: !selectedLocation,
    },
    Warehouse: {
      ...prev.Warehouse,
      value: selectedWarehouse?.locationName || "Select Warehouse",
      options: selectedLocation
        ? selectedLocation.warehouses.map(w => w.locationName)
        : [],
      isPlaceholder: !selectedWarehouse,
    }
  }));
}, [locations, selectedLocationId, selectedWarehouseIndex]);


  const allDocksSelected =
  !!selectedWarehouse?.docks?.length &&
  selectedWarehouse.docks.every((d) => !!d.selected);


useEffect(() => {
  const fetchLocations = async () => {
    setIsLoading(true);
    try {
      const locRes = await fetchLocationsByOfficeCodes();
      const rawLocations = locRes.data ?? [];

      const simpleLocations = rawLocations.map((loc) => ({
        ...loc,
        warehouses: [],
      }));

      setLocations(simpleLocations);
    } catch (err) {
      console.error("❌ Failed to fetch locations:", err);
      setLocations([]);
    } finally {
      setIsLoading(false);
    }
  };

  fetchLocations();
}, []);

useEffect(() => {
  if (lastSettingsLocation?.id && !selectedLocationId) {
    setSelectedLocationId(lastSettingsLocation.id);
  }
}, [lastSettingsLocation, selectedLocationId]);

useEffect(() => {
  if (!selectedLocationId || isLoadingWarehouses) return;
  const loc = locations.find((l) => getLocKey(l) === selectedLocationId);

  if (loc && (!loc.warehouses || loc.warehouses.length === 0)) {
    loadWarehousesForLocation(loc);
  }
}, [selectedLocationId, locations, isLoadingWarehouses, loadWarehousesForLocation]);

useEffect(() => {
  if (
    selectedWarehouseIndex !== null ||
    !lastSettingsWarehouse ||
    !selectedLocationId
  ) {
    return;
  }

  const loc = locations.find((l) => getLocKey(l) === selectedLocationId);
  if (!loc?.warehouses?.length) return;

  const idx = loc.warehouses.findIndex(
    (wh) =>
      wh.locationRef === lastSettingsWarehouse.locationRef ||
      wh.locationName === lastSettingsWarehouse.locationName
  );

  if (idx >= 0) {
    setSelectedWarehouseIndex(idx);
  }
}, [lastSettingsWarehouse, selectedWarehouseIndex, locations, selectedLocationId]);



      const handleAddDock = () => {
      setLocations(prev => {
        const updated = structuredClone(prev);
        const loc = updated.find(l => getLocKey(l) === selectedLocationId);
        const warehouse = loc.warehouses[selectedWarehouseIndex];

        if (!warehouse.additionalDocks) warehouse.additionalDocks = [];

        const newDockId = warehouse.docks.length + warehouse.additionalDocks.length + 1;

        warehouse.additionalDocks.push({
          dockId: newDockId,
          dockName: `Dock ${newDockId}`,
          sameAsWarehouse: false,
          copiedFromWarehouse: false,
          settings: {
            regularHours: {},
            holidays: [],
            blackouts: [],
          },
        });

        return updated;
      });
    };


  const handleSave = async () => {
    if (!selectedWarehouse || selectedWarehouseIndex === null) return;
    const payload = {
      warehouseCalendarRef: selectedWarehouse.calendar.calendarRefId,
      warehouseId: selectedWarehouse.locationRef,
      warehouseSettings: {
        maxCapacity: selectedWarehouse.settings.maxCapacity || 10,
        appointmentDuration:
          selectedWarehouse.settings.appointmentDuration || 120,
        regularHours: { days: selectedWarehouse.settings.regularHours },
        holidays: selectedWarehouse.settings.holidays,
        blackouts: selectedWarehouse.settings.blackouts,
      },
      docks: selectedWarehouse.additionalDocks?.map((dock) => ({
        dockName: dock.dockName,
        sameAsWarehouse: dock.sameAsWarehouse,
        settings: dock.sameAsWarehouse
          ? null
          : {
              maxCapacity: dock.settings.maxCapacity || 10,
              appointmentDuration: dock.settings.appointmentDuration || 120,
              regularHours: {
                days: dock.settings.regularHours,
              },
              holidays: dock.settings.holidays || [],
              blackouts: dock.settings.blackouts || [],
            },
      })),
    };
    console.log("📤 Saving calendar settings with payload:", payload);
   try {
    const res = await axios.post(
      `${process.env.REACT_APP_API_BASE_URL}/api/calendar-setup/getData`,
      payload
    );
    console.log("✅ Save successful, response:", res.data);
    notify.success({
      title: "Calendar Settings Saved",
      message: "Your calendar settings have been saved successfully.",
    });
  } catch (err) {
    console.error("❌ Error saving calendar settings:", err);
    notify.error({
      title: "Save Failed",
      message: "An error occurred while saving calendar settings. Please try again.",
    });
  }
  
  // Refresh current warehouse/dock data without a full page reload
  if (selectedLocation) {
    await loadWarehousesForLocation(selectedLocation);
  }
  };

 return (
  <div className="w-full h-full flex flex-col">

    {/* Sticky Header */}
    <div className="sticky top-0 z-50 bg-white shadow-md w-full">
      <StickyHeader
        mode={{}}
        infoData={infoData}
        onInfoChange={handleInfoChange}
        buttons={[
          {
            label: "Save",
            type: "primary",
            color: "blue",
            onClick: handleSave,
            disabled:
              !selectedWarehouse?.additionalDocks ||
              selectedWarehouse.additionalDocks.length === 0,
          },
        ]}
      />
    </div>

    {/* Main Scrollable Content */}
    <div className="flex-1 overflow-y-auto bg-white p-4 space-y-4">
      <WarehouseDockManagement
        selectedWarehouse={selectedWarehouse}
        selectedLocationId={selectedLocationId}
        selectedWarehouseIndex={selectedWarehouseIndex}
        locations={locations}
        setLocations={setLocations}
        activeTarget={activeTarget}
        setActiveTarget={setActiveTarget}
        allDocksSelected={allDocksSelected}
        openAddDockModal={openAddDockModal}
        setOpenAddDockModal={setOpenAddDockModal}
        onRefreshWarehouse={async () => {
          if (selectedLocation) {
            await loadWarehousesForLocation(selectedLocation);
          }
        }}
      />
    </div>

    {/* Add Dock Modal */}
    {openAddDockModal && (
      <AddDockModal
        warehouse={selectedWarehouse}
        onClose={() => setOpenAddDockModal(false)}
        onSave={(newDock) => {
          setLocations((prev) => {
            const updated = structuredClone(prev);
            const loc = updated.find((l) => getLocKey(l) === selectedLocationId);
            const wh = loc.warehouses[selectedWarehouseIndex];

            if (!wh.additionalDocks) wh.additionalDocks = [];
            wh.additionalDocks.push(newDock);

            return updated;
          });

          setOpenAddDockModal(false);
        }}
      />
    )}

  </div>
);
}

export default CalenderSettings;
